import { useState, useEffect } from 'react';
import { DataServiceHookResponse } from '@dxb-web-ui-framework/common/domain/RestfulDataTransfer/DataService/types';
import { useInvokeSWRService } from '@dxb-web-ui-framework/common/hooks';
import { Nullable } from '@dxb-web-ui-framework/common/types';
import { useExecuteMandateService, useOnSetRequestNewRate, useOnSetAuthAction } from '../../../contexts';
import { ExecuteMandateResponseBody } from '../../../domain/Authorization/entities/ExecuteMandateResponseDTO';

const useMandateExecuteService = (
  successCallback: () => void,
  requestId?: Nullable<string>,
): DataServiceHookResponse<ExecuteMandateResponseBody> => {
  const [timestamp, setTimestamp] = useState<Nullable<string>>(null);
  const executeMandateService = useExecuteMandateService()();
  const shouldExecuteAuthorization = Boolean(requestId) && Boolean(timestamp);

  useEffect(() => {
    if (!timestamp) {
      setTimestamp(new Date().toISOString());
    }
  }, [timestamp]);

  // Initiate Authorization
  return useInvokeSWRService<ExecuteMandateResponseBody>(
    executeMandateService,
    {
      requestId,
      meta: { timestamp },
    },
    shouldExecuteAuthorization,
    'authorizationService.ExecuteMandate',
  );
};

export { useMandateExecuteService };
